/* 图例组件
 * @Author: xiaowei
 * @Date: 2019-12-06 15:40:34
 * @Last Modified by: xiaowei
 * @Last Modified time: 2020-03-18 14:54:32
 */
<template>
    <section :id="legndVue" class="legndVue" :style="'bottom:'+bottom+'px;left:'+left+'px'">
        <div class="title"><span>图例</span></div>
        <div class="unit">(单位:{{unit}})</div>
        <div class="colorHtml">
            <div class="c_left" >
                <div
                    v-for="item,index of styleData"
                    :key="index"
                    :style="colorStyle(item,index)"
                >

                </div>
            </div>
            <div class="c_right">
                <div
                    class="text"
                    v-for="item,index of styleData"
                    :style="'height:'+item.height"
                    :key="index"
                >
                {{ item.text }}
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name:'legnd',
    props:{
        //id
        legndVue:{
            type:String,
            default:'mapLegend'
        },
        //色块配置参数
        styleColor:{
            type:Array,
            default:[]
        },
        //下方位置
        bottom:{
            type:String,
            default:'15'
        },
        //左边位置
        left:{
            type:String,
            default:'55'
        },
        //单位
        unit:{
            type:String,
            default:'mm'
        }
    },
    data(){
        return {
            styleData:[],
            height:'',
            text:''
        }
    },
    watch:{
        styleColor:{
             handler:function(val,oldval){
                this.getStyles(val)
                },

        }
    },
    created(){

    },
    // watch:{
    //    styleData(){
    //        this.colorStyle
    //    }
    // },
    methods:{
        getStyles(val){
            let t = this;
            let arr = [];
            if(!val.length) return;
            let height = $('.colorHtml').height();
            let colorHeight = height / val.length + 'px';

            val.forEach( (item,index) => {
                let a = {};
                a.height = colorHeight;
                if(item[2].fill){
                    a.color = item[2].fillColor;
                }else{
                    a.color = '#ffffff';
                }

                //对降水图例特殊处理
                // if(this.unit == 'mm'){
                    if(!index){
                        a.text = '>'+item[0];
                    }else if(index == val.length -1){
                      a.text = '≤'+item[1];
                    }else{
                        a.text = item[0]+'~'+item[1];
                    }
                // }else{
                //     a.text = item[0]+'~'+item[1];
                // }

                arr.push(a);
            })
            t.styleData = arr;

        },
         colorStyle(item,index){
             if(index == this.styleData.length - 1){
                 return 'height:'+item.height+';background:'+item.color+';border:1px solid;border-bottom:1px solid'
             }else{
                 return 'height:'+item.height+';background:'+item.color+';border:1px solid;border-bottom:none;'
             }
        }
    },
    computed:{

    },
    mounted(){
        this.getStyles(this.styleColor)

    }
}
</script>

<style lang="scss" scoped>
.legndVue{
    width: 90px;
    height: 300px;
    color: #fff;
    background: rgba(57, 77, 101, 0.8);
    position: absolute;
    z-index: 9999;
    border:1px solid rgb(57, 77, 101);
    .title {
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0.6em;
        text-indent: 0.6em;
        text-align: center;
        height: 20px;

    }
    .unit {
            font-size: 12px;
            margin-top: -2px;
            height: 18px;
        }
    .colorHtml {
        height: calc(100% - 38px);
        padding: 0 2px 0 3px;
        display: flex;
        .c_left {
            width: 40%;
            height: 100%;
        }
        .c_right {
            width:60%;
            text-align: left;
            height: 100%;
            font-size: 12px;
            .text {
                display: flex;
                align-items: center;
                text-align: left;
                justify-content: space-between;
                flex-wrap: wrap;
                margin-left: -2px;
                position: relative;
                margin-right: 2px;
                transform: scale(0.8);
            }
            span{

                display: block;
                position: absolute;
            }
        }
        // .color {
        //     display: flex;
        //     .leftColor{
        //         width: 35%;
        //     }
        //    .rightText {
        //        width: 65%;
        //         transform: scale(0.8);
        //         text-align: left;
        //         margin-left: -3px;
        //     }
        // }
    }
}
</style>




// WEBPACK FOOTER //
// src/map/legnd.vue